<div class="row row_ai_center row_jc_center">
  <h1 class="title">Вас приветствует SafeMGR CRM!</h1>
    <form>
      <button type="button" class="dark_btn btn" (click)="login()">Войти</button>
    </form>
  </div>
  